import { Customer } from "definitions/Customer";
import { Ticket } from "definitions/Ticket";
import { User, UserTypes } from "definitions/User";
import React, { ClipboardEvent, useCallback, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { postRequest } from "utils/request";
import Picker, { IEmojiData, SKIN_TONE_MEDIUM_DARK } from "emoji-picker-react";
import Modal from "react-modal";
import { translate } from "translate/i18n";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    minHeight: "30%",
    height: "60%",
    minWidth: "580px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "stretch",
  },
  overlay: {
    overflow: "auto",
    transition: "(top 0.4s, opacity 0.4s)",
    zIndex: 1003,
    background: "rgba(0, 0, 0, 0.4)",
  },
};

type SendTextAndMediaAreaProps = {
  selectedTab: number;
  ticketData: Ticket;
  user: User;
  blockTicket: boolean;
  setTicketHistories: React.Dispatch<React.SetStateAction<Array<unknown>>>;
  input: string;
  setInput: React.Dispatch<React.SetStateAction<string>>;
  customer: Customer;
  selectTicketId: string;
};
export function SendTextAndMediaArea(
  props: SendTextAndMediaAreaProps
): JSX.Element {
  const {
    selectedTab,
    input,
    setInput,
    user,
    blockTicket,
    setTicketHistories,
    ticketData,
    customer,
    selectTicketId,
  } = props;

  const [enablesend, setEnableSend] = useState(true);
  const [pastingPictureString, setPastingPictureString] = useState<
    string | undefined
  >();
  const [pastingPictureBlob, setPastingPictureBlob] = useState<File | null>(
    null
  );
  const [showemojis, setShowEmojis] = useState(false);
  const [isPastingPictureModalOpen, setIsPastingPictureModalOpen] =
    useState(false);

  const closeModal = () => setIsPastingPictureModalOpen(false);

  const onEmojiClick = (
    event: React.MouseEvent<Element, MouseEvent>,
    emojiObject: IEmojiData
  ) => {
    setInput((prevState) => prevState + emojiObject.emoji);
  };

  const sendMessage = async () => {
    if (input !== "" && blockTicket === false) {
      setEnableSend(false);

      if (!ticketData) return;

      //ENVIA MENSAGEM
      const ReturnPost = await postRequest(
        `${
          ticketData.ChannelId !== 5
            ? "/ticketshistories"
            : `/whatsapp/${ticketData.CompanyId}`
        }`,
        {
          TicketId: selectTicketId,
          message: input,
          senderUser: false,
          // agentId: ticket.AgentId, // estava vindo do ticket state( ticketHistories agora)?
          clientNumber: customer?.cellPhone,
        }
      );
      if (ReturnPost.success) {
        setInput("");
        setEnableSend(true);
        setTicketHistories(ReturnPost.data.TicketHistories);
      }
    }
  };

  const handleUpload = useCallback(
    //@ts-ignore
    (file) => {
      if (!ticketData) return;
      setEnableSend(false);
      const formData = new FormData();
      formData.append("TicketId", selectTicketId);
      formData.append("senderUser", "false");
      formData.append("file", file);
      formData.append("clientNumber", customer?.cellPhone || "");
      console.log("handleUpload formData", formData);
      postRequest(
        `${
          ticketData.ChannelId !== 5
            ? "/ticketshistories/file"
            : `/whatsapp/${ticketData.CompanyId}/upload`
        }`,
        formData,
        {
          "Content-Type": "multipart/form-data",
        }
      )
        .then(function (response) {
          setTicketHistories(response.data.TicketHistories);
          setEnableSend(true);
          if (isPastingPictureModalOpen) {
            setIsPastingPictureModalOpen(false);
            setPastingPictureBlob(null);
            setPastingPictureString(undefined);
          }
        })
        .catch((error) => {
          setEnableSend(true);
          if (isPastingPictureModalOpen) {
            setIsPastingPictureModalOpen(false);
            setPastingPictureBlob(null);
            setPastingPictureString(undefined);
          }
        });
    },
    [
      setEnableSend,
      setTicketHistories,
      selectTicketId,
      customer?.cellPhone,
      ticketData,
      isPastingPictureModalOpen,
      setIsPastingPictureModalOpen,
      setPastingPictureBlob,
      setPastingPictureString,
    ]
  );

  const handleUploadByButton = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (
      event &&
      event.target &&
      event.target.files &&
      event.target.files.length
    )
      handleUpload(event.target.files[0]);
  };

  const handleUploadByPastingImage = () => {
    handleUpload(pastingPictureBlob);
  };

  const textareaRef = useCallback(
    //@ts-ignore
    (node) => {
      const pasteAction = (evt: ClipboardEvent) => {
        let isImagePasted = false;
        const items = evt.clipboardData.items;
        for (let i = 0; i < items.length; i++) {
          if (items[i].type.startsWith("image/")) {
            const blob = items[i].getAsFile();
            setPastingPictureBlob(blob);
            const reader = new FileReader();
            reader.onload = (e) => {
              if (e.target && typeof e.target.result === "string") {
                setPastingPictureString(e.target.result);
              }
            };
            if (blob) reader.readAsDataURL(blob);
            isImagePasted = true;
          }
        }

        if (isImagePasted) {
          setIsPastingPictureModalOpen(true);
          // Let the browser handle the default paste action if no image is pasted
        } else {
          return; // Allow the default behavior (pasting text) to proceed
        }
      };
      if (node) {
        node.addEventListener("paste", pasteAction);
      }
    },
    [handleUpload]
  );

  // caso opção enterKeySendsMessage seja true,
  // no input do chat, enter envia msg, e ctrl/shift + enter cria nova linha
  const handleKeyDown: React.KeyboardEventHandler<HTMLTextAreaElement> = (
    event
  ) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (event.shiftKey || event.ctrlKey || !user.enterKeySendsMessage) {
        setInput((prevInput) => prevInput + "\n");
      } else {
        sendMessage();
      }
    }
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        marginBottom: 0,
      }}
    >
      <div
        className="col"
        style={{ backgroundColor: "white", marginBottom: 8 }}
      >
        <div className="bg-light p-2 rounded">
          <form
            className="needs-validation"
            // noValidate=""
            name="chat-form"
            id="chat-form"
            style={{ height: "100%" }}
            onSubmit={(e) => {
              e.preventDefault();
              sendMessage();
            }}
          >
            <div
              className="row"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="col mb-2 mb-sm-0">
                <textarea
                  className="form-control border-0"
                  style={{ resize: "none" }}
                  rows={1}
                  ref={textareaRef}
                  value={input}
                  disabled={
                    blockTicket ||
                    selectedTab === 1 ||
                    (user.UserTypeId !== UserTypes["Gerente IH"] &&
                      user.id !== ticketData?.AgentId)
                  }
                  onChange={(value) => setInput(value.target.value)}
                  onKeyDown={handleKeyDown}
                ></textarea>
              </div>
              <div className="col-sm-auto">
                <div
                  className="btn-group"
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  {enablesend ? (
                    <>
                      <button
                        className="btn btn-light"
                        style={{
                          backgroundColor: "#ddd",
                          border: "1px",
                          padding: 0,
                        }}
                        disabled={
                          blockTicket ||
                          selectedTab === 1 ||
                          (user.UserTypeId !== UserTypes["Gerente IH"] &&
                            user.id !== ticketData?.AgentId)
                        }
                      >
                        <label
                          htmlFor="file-input"
                          className="uil uil-paperclip"
                          style={{
                            display: "flex",
                            width: "100%",
                            height: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            padding: 14,
                          }}
                        ></label>
                        <input
                          id="file-input"
                          type="file"
                          style={{ display: "none" }}
                          onChange={handleUploadByButton}
                          disabled={
                            !enablesend ||
                            blockTicket ||
                            selectedTab === 1 ||
                            (user.UserTypeId !== UserTypes["Gerente IH"] &&
                              user.id !== ticketData?.AgentId)
                          }
                        />
                      </button>

                      <button
                        type="button"
                        className="btn btn-warning"
                        disabled={
                          blockTicket ||
                          selectedTab === 1 ||
                          (user.UserTypeId !== UserTypes["Gerente IH"] &&
                            user.id !== ticketData?.AgentId)
                        }
                        onClick={() => setShowEmojis((prev: boolean) => !prev)}
                      >
                        <i className="uil uil-smile"></i>
                      </button>
                      <button
                        type="submit"
                        className="btn btn-success"
                        disabled={
                          blockTicket ||
                          selectedTab === 1 ||
                          (user.UserTypeId !== UserTypes["Gerente IH"] &&
                            user.id !== ticketData?.AgentId)
                        }
                      >
                        <i className="uil uil-message"></i>
                      </button>
                    </>
                  ) : (
                    <CircularProgress className="loading-send-chat" size={20} />
                  )}
                </div>
              </div>
            </div>
            <div>
              {showemojis ? (
                <Picker
                  pickerStyle={{ marginTop: "10px", width: "100%" }}
                  onEmojiClick={onEmojiClick}
                  disableAutoFocus={true}
                  skinTone={SKIN_TONE_MEDIUM_DARK}
                  groupNames={{ smileys_people: "PEOPLE" }}
                />
              ) : (
                ""
              )}
            </div>
          </form>
        </div>
      </div>
      {/* @ts-ignore */}
      <Modal
        isOpen={isPastingPictureModalOpen}
        //@ts-ignore
        style={customStyles}
        onRequestClose={closeModal}
        ariaHideApp={false}
      >
        <div
          style={{
            // border: "2px solid red",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 20,
          }}
        >
          {pastingPictureString && (
            <img
              style={{
                maxWidth: "500px",
              }}
              src={pastingPictureString}
              alt="Pasted from clipboard"
            />
          )}
          <p className="mb-0">{translate("confirmPostImage")}</p>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              className="btn btn-outline-danger"
              onClick={closeModal}
              type="button"
            >
              {translate("cancel")}
            </button>
            <button
              className="btn btn-outline-success"
              onClick={handleUploadByPastingImage}
            >
              {translate("send")}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
